import React from 'react'
import ContentWrapper from '../components/ContentWrapper'
import {
	legalName,
	COMPANY_STREET,
	COMPANY_POSTAL_CODE,
	COMPANY_CITY,
	COMPANY_HANDELSREGISTER,
	COMPANY_REGISTERGERICHT,
	GESCHAEFTSFUEHRER,
	COMPANY_PHONE,
	COMPANY_EMAIL,
} from '../consts'

const ImpressView = (): JSX.Element => {
	return (
		<ContentWrapper p="1rem">
			<h1>Impressum</h1>

			<p>
				{legalName}
				<br />
				{COMPANY_STREET}
				<br />
				{COMPANY_POSTAL_CODE} {COMPANY_CITY}
			</p>

			<p>
				Handelsregister: {COMPANY_HANDELSREGISTER}<br />
				Registergericht: {COMPANY_REGISTERGERICHT}
			</p>

			<p>
				<strong>Vertreten durch:</strong>
				<br />
				{GESCHAEFTSFUEHRER}
			</p>

			<h2>Kontakt</h2>
			<p>
				Telefon: {COMPANY_PHONE}
				<br />
				E-Mail: {COMPANY_EMAIL}
			</p>

			<h2>EU-Streitschlichtung</h2>
			<p>
				Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
				bereit:{' '}
				<a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
					https://ec.europa.eu/consumers/odr/
				</a>
				.<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
			</p>

			<h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
			<p>
				Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
				Verbraucherschlichtungsstelle teilzunehmen.
			</p>
		</ContentWrapper>
	)
}

export default ImpressView
